module.exports = __webpack_public_path__ + "img/is-tim-mcgraw-bald.25fc2362.jpg";